import { useEffect } from "react";

const HEADER_HEIGHT = 68;

const useDynamicHeight = () => {
    const root = document.documentElement;

    const syncViewport = () => {
        const vv = window.visualViewport;
        if (!vv) return;

        // Calculate new top offset
        // based on the default browser visualViewport offset
        // to make only header hidden
        const offsetTop = vv.offsetTop
            ? vv.offsetTop > HEADER_HEIGHT
                ? vv.offsetTop - HEADER_HEIGHT
                : (HEADER_HEIGHT - vv.offsetTop) * -1
            : 0;
        const isViewportOffset = Math.abs(offsetTop) > 0;
        // if there's offset in the top we need to increase height in order to fill all viewport height and to not have space in the bottom
        const height = isViewportOffset ? vv.height + HEADER_HEIGHT : vv.height;

        root.style.setProperty("--vv-height", `${height}px`);

        // Only set transform offset when there's actual offset, otherwise remove it
        if (isViewportOffset) {
            root.style.setProperty("--vv-offset", `${offsetTop}px`);
        } else {
            root.style.removeProperty("--vv-offset");
        }
    };

    // scroll to the anchor if it's on the active screen
    // now anchor is a Badges component on DecimalInput
    const scrollToAnchor = () => {
        const container = document.querySelector(".active-question");
        const anchor = container?.querySelector(".scroll-anchor");

        if (anchor && container) {
            const containerTop = container.getBoundingClientRect().top;
            const anchorTop = anchor.getBoundingClientRect().top;

            container.scrollTo({
                top: container.scrollTop + (anchorTop - containerTop),
                behavior: "smooth",
            });
        }
    };

    useEffect(() => {
        syncViewport();

        const handler = () => {
            syncViewport();
            scrollToAnchor();
        };

        window.visualViewport?.addEventListener("resize", handler);
        window.visualViewport?.addEventListener("scroll", handler);

        return () => {
            window.visualViewport?.removeEventListener("resize", handler);
            window.visualViewport?.removeEventListener("scroll", handler);
        };
    }, []);
};

export default useDynamicHeight;
